import { Image } from "@chakra-ui/react";
import type { ImageProps, LayoutProps } from "@chakra-ui/react";
import {LogoBlack, LogoOrange} from './logo-svg'
import logoWhiteSvg from './dystans_logotyp_white.svg'

export default function Logo(
  {logoColor, ...props}: {
    logoColor: 'black' | 'orange' | 'white';
    width: LayoutProps['width'];
    loading?: ImageProps['loading'];
    fetchPriority?: ImageProps['fetchPriority']
  }) {
  if (logoColor === 'white') {
    return  <Image alt="wydawnictwo dystans białe logo" src={logoWhiteSvg} {...props} />
  }
  if (logoColor === 'orange') {
    return <LogoOrange {...props}/>
  }

  return  <LogoBlack {...props} />
}